import { render, staticRenderFns } from "./detail-standard.vue?vue&type=template&id=4249baf9&"
import script from "./detail-standard.vue?vue&type=script&lang=js&"
export * from "./detail-standard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports